import { DatePipe, formatDate, Location , DOCUMENT } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef,  HostListener, Inject, Input, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ShowcaseDialogComponent } from '@app/shared/components';
import { InfoDialogComponent } from '@app/shared/components/dialog/info-dialog/info-dialog.component';
import { DynamicFormCommonService } from '@app/shared/dynamic-form-common.service';
import { PhonePipe } from "@app/shared/pipes/phone.pipe";
import { AuthService } from '@app/shared/services';
import { EventEmiterService } from '@app/shared/services/event-emiter.service';
import { MessageService } from '@app/shared/services/message.service';
import { SocketService } from '@app/shared/services/socket.service';
import * as moment from 'moment';
import {
  NbDialogService,
  NbMediaBreakpointsService,
  NbMenuService,
  NbPopoverDirective,
  NbSidebarService,
  NbThemeService,
  NbToastrService,
} from '@nebular/theme';
import { NgPluralizeService } from 'ng-pluralize';
import { Observable, Subject, Subscription } from 'rxjs';
import 'rxjs/add/observable/interval';
import { fromEvent } from 'rxjs/internal/observable/fromEvent';
import { map, takeUntil, throttleTime } from 'rxjs/operators';
import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { RippleService } from '../../../@core/utils/ripple.service';
import { ChatSubscriptionService } from '../../../shared/services/chat-subscription.service';
import { FilterForService, TableService } from '../../../shared/services/table.service';
import { ReminderService } from '@app/shared/services/reminder-service.service';
@Component({
  selector: "ngx-header",
  styleUrls: ["./header.component.scss"],
  templateUrl: "./header.component.html",
})
export class HeaderComponent implements OnInit, OnDestroy {
  clickEventsubscription: Subscription;
  private destroy$: Subject<void> = new Subject<void>();
  public readonly materialTheme$: Observable<boolean>;
  userPictureOnly: boolean = false;
  user: any;
  condtion = false;
  timeout;
  keySubscription: Subscription;
  mouseSubscription: Subscription;
  isActive = true;
  userId = "";
  actionSubscription: Subscription;
  logoPathSubscription: Subscription;
  refreshHeaderSubscription: Subscription;
  notificationCount = 0;
  notificationBadgeText = "";
  showNotification = false;
  showUserCard: boolean = false;
  isAnnounceRead = true;
  announcement: any = [];
  allowedUserStatus = ["Online", "Away"];
  cavalryLogo = {
    path: "",
    height: 45,
    cssClass: "cavalry-logo",
  };
  audioSource: string = "assets/new_notification.mpeg";
  audioFile: HTMLAudioElement;
  reminderListSubscription: Subscription;
  redirectLinkSubscription: Subscription;
  unreadNotificationCount = 0;
  userProfileMenu = [{ title: "Call Log Configurations" }, { title: "Profile" }, { title: "Users" }, { title: "Account" }, { title: "Integrations" }, { title: "System Configurations" }];
  items = [
    { icon: { icon: 'python', pack: 'edit' } },
    // -- { icon: { icon: 'python', pack: 'view' } },
    // { icon: { icon: 'python', pack: 'delete' } },
  ];
  currentTheme = "default";
  userMenu = [{ title: "Profile" }, { title: "Log out" }];
  notificationMenu = [
    {
      notificationId: "",
      title: "No new notification!",
      tableId: "",
      tableName: "",
      reminderNotes: '',
      resourceId: "",
      subject: "",
      description: "",
      resourceName: "",
      notes: "",
      isNewMessage: false,
      subscribers: [],
      details: '',
      dateTime: new Date(),
      toDisplay: [],
      tableIcon: {},
    },
  ];

  isGearIcon = false;
  quickActionList = [];
  username = "";
  count = 0;
  numberOfPagesLoadedReminder = 0;
  numberOfPagesLoadedNotification = 0;
  @Input() getSystemConfigVariable;
  @Input() tableName: string;
  @Input() fromRecordPage = false;
  @Input() getTableByNameObject = {};
  @Input() fromDummy = false;
  @Input() layout = null;
  @Input() showReminderLayout = false;
  headerObj = {};
  parentTableHeader = [];
  tableNameWithoutS: string;
  tableData: any = [];
  getTableByNameFlagCalled = false;
  subFormLookupIds: any;
  taskStatus = [];
  taskRecordTypes: any = [];
  tableRecordTypes: any = [];
  condition = [false];
  headerWidth = 0;
  accessTableName = [];
  actions = [];
  formLayouts = [];
  tutorials = [];
  tutorial = "";
  recordGadgets;
  showChats;
  finalPageLayout = null;
  ejsPackage;
  parentTableData = [];
  displayRecordGadgets = false;
  pageLayoutSide = '';
  isCenterPageLayout = {
    mode: '',
    logic: ''
  };
  displayCenterLogic;
  isDefaultFilterApplied = false;
  pageLayout = [];
  customValidations;
  allowSubtree = {};
  subTreeTable = {};
  formHeight;
  formWidth;
  fieldAlignment;
  viewInModal = false;
  provideFiles = false;
  enableCSV = false;
  kanbanViewEnable = false;
  tableHasKanbanView = false;
  viewAllRecords = false;
  resColData = {};
  resultData = [];
  dynamicFilterData: any;
  canAddNewRecord = false;
  lookTable: any;
  lookupName: any;
  showAutocomplete = {};
  lookupData: any = [];
  lookupValue = {};
  showFilterBox = {};
  hideColumn = {};
  filterObject: FilterForService;
  filteredOptions = {};
  search: any;
  demoData: [];
  dependsFields = [];
  allParentTableHeader;
  statuses = [];
  forkJoinTableDataObject: any = {};
  forkJoinDataForTables;
  tableId: string;
  datafetched = false;
  tempParentTableHeader = [];

  isEmailField = false;
  phoneField = {};
  refButtonField = {};
  allLookupsList = [];
  selectedGroupBy = '';
  recordTypeFieldName: string = null;
  recordTypes = [];
  statusArray = [];
  statusName = "";
  filteredStatus = {};
  finalList = [];
  sortObject: any = null;
  allFilters = [];
  readyForPageLayout = false;
  defaultStyleFlag = null;
  fromOverview = false;
  hasUserPreference = false;
  tagList = [];
  allUsers = [];
  searchString: string = null;
  viewCompletedRecords = false;
  searchMode = "no";
  loading = false;
  fromDashboard = false;
  pageNo = 0;
  @Input() directViewFlag;
  @Input() directViewId = null;
  @Input() directTableName;
  @Input() rowId;
  @Input() parentTableNameFromView;
  @Input() parentTableDataFromView;
  @Input() lookUpNameId;
  @Input() lookUpName;
  @Input() renderAt;
  isPopupOpen = false;
  currentUser;
  recordType: string = null;
  pager: any = {};
  newViewFlag = false;
  // tableIcons = "";
  previousLocation: string;
  chartFilter = [];
  filterDefaultList;
  userPreferences = [];
  restoreObj = {
    filterKey: [],
    tagList: [],
  };
  kanbanLoader = false;
  lookupObj = {};
  isDefaultValueEnable: boolean = false;
  usersWithIds = [];
  callCount: any = 0;
  recordTypeFilter;
  taskedRecordsOnly = false;
  watchedIssue = false;
  listingDataObj = {};
  idFieldsArray = [];
  otherFieldsArray = [];
  finalStatusArray = [];
  dataForApiResponseOfIndividualStatus = {};
  individualStatusPageCount = {};
  loadingIndividual = {};
  pageOfItems = [];
  checkCount = 0;
  public masterSearchTab: any[] = [];
  public isSearchPage: boolean = false;
  noDataFound = false;
  gadgetFieldValue = [];
  activCallData: any;
  reMinderData = [];
  unReadReminder = []

  @ViewChild(NbPopoverDirective) popover;
  systemConfigColor: any;
  systemShadow: any;
  userEmail: any;
  firstName: any;
  sub: any;
  tableIcon: any;
  anounceList: any = [];
  onCloseEvnet = false;

  OpenModelEvent : boolean = false;

  showAddReminder = false;
  userData: any;

  reminderList = [];
  notificationList = [];
  unreadCount: number;

  public constructor(
    @Inject(DOCUMENT) private document: Document,
    public route: ActivatedRoute,
    private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private userService: UserData,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    private rippleService: RippleService,
    private socketService: SocketService,
    private authService: AuthService,
    private router: Router,
    private chatSubscriptionService: ChatSubscriptionService,
    private tableService: TableService,
    private messageService: MessageService,
    private renderer: Renderer2,
    private dialogService: NbDialogService,
    private datePipe: DatePipe,
    private cdr: ChangeDetectorRef,
    private eventEmiter: EventEmiterService,
    private service: NgPluralizeService,
    private title: Title,
    private sanitizer: DomSanitizer,
    private location: Location,
    private elem: ElementRef,
    private formService: DynamicFormCommonService,
    private reminderService: ReminderService,
    private toastrService: NbToastrService
  ) {
    this.materialTheme$ = this.themeService.onThemeChange().pipe(
      map((theme) => {
        const themeName: string = theme?.name || "";
        return themeName.startsWith("material");
      })
    );
    this.tableService.$systemConfig.subscribe((res: any) => {
      if (res) {
        this.systemConfigColor = res.IconColors;
        if (this.systemConfigColor != undefined) {
          this.systemShadow = this.hexToRgb(this.systemConfigColor)
        }
      }
    })
    this.userData = JSON.parse(localStorage.getItem("userData"));
    this.userId = JSON.parse(localStorage.getItem("userData"))._id;
    this.userEmail = JSON.parse(localStorage.getItem("userData")).email;
    this.actionSubscription = this.menuService
      .onItemClick()
      .subscribe((event: any) => {
        if (event.item.title === "Log out") {
          this.authService.logout();
        }
        if (event.item.title === "Profile") {
          const userTableId = "5f60cb6e10fd660a92e9b416";
          this.router.navigateByUrl(
            `pages/tables/dynamic/${userTableId}/Users/${this.userId}`
          );
        }
      });

    this.renderer.listen("window", "click", (e: Event) => {
      const ele = document.getElementById('rem-not');
      const checkOpen = document.getElementById('checkOpen');

      if(!this.showAddReminder){
        if (ele && ele.contains(<Node>e.target)) {
          this.showNotification = true;
        } else {
          if(!checkOpen){
            this.showNotification = false;
          }
        }
      }
    });

    if (JSON.parse(localStorage.getItem('userData')) && localStorage.getItem('isFirstTime')) {
      this.getUserDetail();
    }

    if (JSON.parse(localStorage.getItem('userData')) && (localStorage.getItem("isButtonClick") === "true" || localStorage.getItem("openAnnounceModal") == "true")) {
      this.openAnnouncementBox();
    }

    this.logoPathSubscription = tableService.logo.subscribe(count => {
      this.cavalryLogo.path = count;
    })

    // this.clickEventsubscription = this.eventEmiter.getReminderClick().subscribe(() => {
    //   this.openReminderModal();
    // })
    this.tableService.getTablesForMenu().subscribe((res) => {
      if (res) {
        let announcement = res['data'].find((x: any) => x.tableName == "Announcements")
        if (announcement && announcement?.displayInMenu && announcement?.displayInMenu == true) {
          this.eventEmiter.Announcments = true;
        }
      }
    })
  }

  ShowHideModel(){
    this.showAddReminder = !this.showAddReminder
    if(this.showAddReminder == false){
    //  this.getRemindersList();
      setTimeout(() => {
        const ele = document.getElementById('checkReminderCallS');
        if(ele){
          ele.click()
        }
      },1000)
    }
  }
  hexToRgb(hex) {
    let res = hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i
      , (m, r, g, b) => '#' + r + r + g + g + b + b)
      .substring(1).match(/.{2}/g)
      .map(x => parseInt(x, 16))
    if (res.length > 0) {
      return 'rgba(' + res[0] + ',' + res[1] + ',' + res[2] + ',' + '50%)';
    }
  }
  showSettings = true;
  getTablesForMenu() {
    this.tableService.getTablesForMenu().subscribe(((res: any) => {
      if (res.statusCode == 200) {
        this.getTablesForMenuData = res.data;
        this.quickActionList = this.getTablesForMenuData.filter(v => v.quickAction).map(ele => ele.tableName);
        let setting = this.getTablesForMenuData.filter(v => v.tableName == 'Assigned Permissions');
        if (setting.length == 0) {
          this.showSettings = false;
        } else {
          this.userProfileMenu.splice(2, 0, { title: 'Settings' });
          this.userProfileMenu.splice(3, 0, { title: 'Field Restrictions' });
          this.userProfileMenu.splice(4, 0, { title: 'Assigned Permissions' });
        }
        let uniqueDataArray = this.userProfileMenu.filter((value, index, self) =>
           index === self.findIndex(obj => obj.title === value.title)
        );
        this.userProfileMenu = uniqueDataArray;
      }
    }))

  }

  @HostListener('document:click', ['$event'])
  public documentClick(event: any): void {
    let icon = document.getElementById('menu-id');
    let mobileIcon = document.getElementById('mobile-toggler');
    let ele = document.getElementsByClassName('menu-sidebar')[0];
    if (event.target.id === "announcements-btn") {
      localStorage.setItem('isButtonClick', 'true');
    }
    if (icon || mobileIcon) {
      if (icon.contains(event.target) || mobileIcon) {
        if (ele) {
          if (ele.classList.contains('expanded')) {
            this.tableService.setSearchInput(true);
          } else {
            this.tableService.setSearchInput(false);
          }
        }
      } else {

        if (ele) {
          if (ele.classList.contains('expanded')) {
            this.sidebarService.toggle(true, "menu-sidebar");
            this.layoutService.changeLayoutSize();
            this.tableService.setSearchInput(false);
          } else {
            this.tableService.setSearchInput(false);
          }
        }
      }
    }

    if (event.target.id == 'tableSearch') {
      if (ele) {
        if (!ele.classList.contains('expanded')) {
          this.sidebarService.toggle(true, "menu-sidebar");
          this.layoutService.changeLayoutSize();
          this.tableService.setSearchInput(true);
          setTimeout(() => {
            document.getElementById("search_tab_input").focus();
            this.tableService.runCustomStyling();
          }, 0);
        }
      }
    }

    setTimeout(() => {
      this.tableService.runCustomStyling();
    }, 260)

  }

  messageList = [];

  async ngOnInit() {

    this.tableName = "Call Log";
    this.checkReminderCount()
    if(this.showReminderLayout){
       return false
    }
    if(localStorage.getItem("isFirstTime")){
      // this.openReminderOneByOne(0)
    this.getRemindersList()

    }

    this.changeUserStatus();
    //this.getTableByName();
    //this.getTasks();
    this.getTablesForMenu();
    this.getActiveCall()
    this.listenRecordReminders();

    this.currentTheme = this.themeService.currentTheme;
    // this.getUnreadMessages();
    if (localStorage.getItem("userData")) {
      const userData = JSON.parse(localStorage.getItem("userData"));
      this.isGearIcon = userData.isGearIcon;
      this.username = (
        userData.firstName +
        " " +
        userData.lastName
      ).toUpperCase();
      this.firstName = userData.firstName
    }

    await this.getAnnouncementList();

    this.socketService.listen("room_message").subscribe((res: any) => {

      let id = res.sender?._id ? res.sender?._id : res.sender;
      // if (id !== this.userId) {
      this.chatSubscriptionService.getSubscribers(res.resourceDetails.resourceId).subscribe((resp: any) => {
        if (resp.data) {
          let user = resp.data.find(v => v._id == this.userId);
          if (user) {
            if (res.messageType == 'log') {
              this.notificationList.unshift(res);
              this.notificationBadgeText = ".";
              this.unreadNotificationCount++;
              this.emitMessageSound();
              this.tableService.refreshMessageLayout();
            } else {
              this.messageList.unshift(res);
              this.tableService.getRecordSpecificMessages(this.messageList.slice(0, 3));
              this.tableService.refreshMessageLayout();
            }
          }
          // this.emitMessageSound();
        }
      })
      // }
    });
    //new record
    this.socketService.listen("new_record_created").subscribe((data: any) => {
      let checkUser = data.data?.lookup.find((item) => item.lookupId == this.userId)
      if (data.data?.lookup.length > 0 && checkUser) {
        if (data.tableName == "Call Log" && data?.data?.callType == "Active Call") {
          this.activCallData = data.data
          setTimeout(() => {
            this.tableService.runCustomStyling();
          }, 1000);
        }
      }
      if (this.announcement) {
        if (data.tableName == "Announcements") {
          setTimeout(() => {
            // this.getUserDetail();
            this.getAnnouncementList();
            if (localStorage.getItem("openAnnounceModal") == "false") {
              localStorage.setItem("openAnnounceModal", "true")
            }
            // localStorage.setItem('isFirstTime', 'true');
            this.tableService.runCustomStyling();
          }, 2000);
        }
      }
    })

    //-- Watcher added

    this.socketService.listen("new_watcher_created").subscribe((data: any) => {

      let checkUser = data.watchersIDs?.find((id) => id == this.userId)
      if(checkUser){
        //-- Push to notification
        this.numberOfPagesLoadedNotification++;
        this.notificationList.unshift(data.log);
        this.notificationBadgeText = ".";
        this.unreadNotificationCount++;
        this.emitMessageSound();
        this.tableService.refreshMessageLayout();
        this.toastrService.success('',data.log.text);
      }
    })

    //delete record
    this.socketService.listen("delete_record").subscribe((data: any) => {
      if (data.activeData && data.activeData == 1) {
        delete data.activeData;
        let checkUser = data?.lookup.find((item) => item.lookupId == this.userId)
        if (data?.lookup.length > 0 && checkUser) {
          this.activCallData = data
        }
      } else {
        this.activCallData = null;
        setTimeout(() => {
          this.tableService.runCustomStyling();
        }, 1000);

      }
    })

    //update record
    this.socketService.listen("update_record").subscribe((data: any) => {

      let checkUser = data.data?.lookup.find((item) => item.lookupId == this.userId)
      if (data.data?.lookup.length > 0 && checkUser) {
        if (data.tableName == "Call Log" && data?.data?.callType == "Active Call") {
          this.activCallData = data.data
          setTimeout(() => {
            this.tableService.runCustomStyling();
          }, 1000);
          // this.tableService.refreshHeaderComponent();
        } else {
          this.activCallData = null;
        }
      }
      if (data.tableName == "Announcements") {
        setTimeout(() => {
          this.getUserDetail();
          this.tableService.runCustomStyling();
        }, 2000);
      }
    })

    this.userService
      .getUsers()
      .pipe(takeUntil(this.destroy$))
      .subscribe((users: any) => (this.user = users.nick));

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService
      .onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$)
      )
      .subscribe(
        (isLessThanXl: boolean) => (this.userPictureOnly = isLessThanXl)
      );

    this.themeService
      .onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$)
      )
      .subscribe((themeName) => {
        this.currentTheme = themeName;
        this.rippleService.toggle(themeName?.startsWith("material"));
      });


    // for chat functions
    this.setStatusChangeTimer();
    this.keyPressSubscription();
    this.mouseMoveSubscription();
    this.chatSubscriptionService.getSubscriptions();
    this.getChatSubscription();
    this.getAllUsers();

    setTimeout(() => {
        this.getNotificationsList();
        this.listenGeneralReminders();
        this.listenRecurring();
        if(localStorage.getItem("isFirstTime")){
          this.openReminderOneByOne(0)
          localStorage.removeItem("isFirstTime")
        }
    }, 3000)

    // setTimeout(() => {
    //   this.getAnnouncement();
    // }, 1000)

    // this.sub = Observable.interval(1000)
    //   .subscribe((val) => { this.checkRemindStatus();});


    this.tableService.refreshHeader.subscribe((res: any) => {
      this.getTablesForMenu();
    })

    this.bufferAudioFile();

    // this.tableService.viewReminder.subscribe((r)=>{
    //   if(r){
    //     this.readNotifications();
    //   }
    // })
  }

  openReminderOneByOne (number? : number) {
    const currentDate = moment();
    // const isPastDue = moment(dueDate).isBefore(currentDate);
    const findUnreadRecords = this.reminderList?.filter((res) => res?.visibilityStatus == "unread" && moment(res?.dueDate).isBefore(currentDate))
    this.unreadCount = findUnreadRecords?.length;
    const getRecord = findUnreadRecords[number];
    if (number <= this.unreadCount) {
      this.showReminder(getRecord, number);
    }
    console.log(number <= this.unreadCount)
  }


  showReminder(reminder , number? : number) {
    reminder.reminderDetails = reminder;
    this.dialogService.open(InfoDialogComponent, {
      closeOnEsc: false,
      closeOnBackdropClick: false,
      context: {
        title: ``,
        text: "",
        dialogType: "reminder",
        notification: reminder,
      },
    }).onClose.subscribe((res) => {
      this.OpenModelEvent = false;
      if(number || number == 0){
          this.openReminderOneByOne(number + 1)
      }

    });
  }

  checkReminderCount(){
    this.reminderService.getReminderCount().subscribe((res:any) => {
      this.unreadReminderCount = res.data;
    })
  }

  async getAnnouncementList() {
    let responce: any = await this.tableService.GetDynamicTableWithoutPagination("Announcements", "no", true)
    this.anounceList = responce.data;
  }
  async getActiveCall() {
    let response: any = await this.tableService.getDynamicTreeData("Call Log", 1, "", { column: "timeOfCall", direction: "desc" }, [{ "assignedTo": [this.userId] }, { "callType": ["Active Call"] }]);
    if (response && response.data?.pageOfItems && response.data.pageOfItems.length > 0) {
      this.activCallData = response.data.pageOfItems[0];
    }
  }

  // async openCallDetailModal(data) {
  //   let tableData: any = await this.tableService.getTableByName("Call Log");
  //   this.tableId = tableData.data[0]._id;
  //   this.tableName = tableData.data[0].tableName;
  //   this.viewInModal = tableData.data[0].viewInModal ? tableData.data[0].viewInModal : null;
  //   if (tableData.data[0] && this.tableId && this.tableName) {
  //     if (tableData.data[0].tableName == this.tableName) {
  //       this.tdClick(this.tableId, this.tableName, data._id, this.viewInModal);
  //       this.backDrop();
  //     }
  //   }
  // }

  // -- Open record for view in modal or old view mode
  tdClick(tableId, tableName, _id, modal) {
    if (tableId) {
      this.previousLocation = this.location.path();
      if (modal) {
        this.tableService
          .getDynamicTreeDataById(tableName, _id)
          .pipe(takeUntil(this.destroy$))
          .subscribe((res: any) => {
            if (res.statusCode == 200) {
              this.openViewModal(res.data, _id);
              this.isPopupOpen = false;
              this.actionSubscription.unsubscribe();
            }
          });
      } else {
        this.location.replaceState(this.previousLocation);
      }
    }
    this.eventEmiter.idField = this.eventEmiter.idField.filter(
      (v, i, a) => a.findIndex((t) => t.idField === v.idField) === i
    );
    localStorage.setItem("IdFields", JSON.stringify(this.eventEmiter.idField));
  }

  // -- Open view mode of record
  async openViewModal(data, id) {

    let val: any = await this.formService.openAndCloseForm(data, this.tableName, this.tableData, true, this.recordType);

    const ref = this.dialogService.open(val.formComp, {
      closeOnEsc: false,
      closeOnBackdropClick: false,
      context: val.formObj,
    }).onClose.subscribe((resp) => {
      this.location.replaceState(this.previousLocation);
    });
  }

  fireUserPrefUpdate() {
    this.tableService.updateDynamicFormData(this.currentUser._id, 'Call Log', { userPreferences: this.userPreferences })
      .pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
        if (res.statusCode === 200) { }
      });
  }

  saveUserPreference(unset = false, fromDefult?) {

    if (!fromDefult)
      this.filterObject.lastFilterSelected = "";

    if (this.userPreferences && this.userPreferences.length) {
      let tableDataIndex = this.userPreferences.findIndex(ele => ele.tableName == this.filterObject.tableName);
      if (tableDataIndex > -1) {

        // if (unset) {
        //   this.userPreferences.splice(tableDataIndex, 1);
        //   this.fireUserPrefUpdate();
        //   return;
        // }
        this.userPreferences[tableDataIndex] = this.filterObject;

      } else {
        this.userPreferences.push(this.filterObject);
      }

      this.fireUserPrefUpdate();

    } else {

      // if (!unset) {
      this.userPreferences.push(this.filterObject);
      this.fireUserPrefUpdate();
      // }
    }

    if (!fromDefult)
      this.isDefaultFilterApplied = false;


    this.cdr.detectChanges();

  }


  responseOfAllStatus = [];

  groupBy(objectArray, property, allowed?) {

    return objectArray.reduce((acc, obj) => {
      const key = obj[property];
      if (!acc[key]) {
        acc[key] = [];
      }
      // Add object to list for given key's value
      if (allowed) {
        if (obj.allowed)
          acc[key].push(obj);
      } else {
        acc[key].push(obj);
      }

      return acc;
    }, {});
  }

  setIsPhoneForLookup(inde, lookup, element) {
    if (inde > -1) {
      if (this.lookupData[inde].isReference) {
        const col = this.parentTableHeader.filter(
          (v) => v.type == "refButton"
        );
        if (col && col.length) {
          if (!element[col[0].label]) element[col[0].label] = [];
          element[col[0].label].push(lookup);
        }
      }
      if (!element[lookup.lookupName]) element[lookup.lookupName] = [];
      element[lookup.lookupName].push(lookup);

      let idFields = [];
      let valueToDisplay = [];
      let table = this.tableData.filter(v => v.tableName == this.lookupData[inde].lookupTableName);
      if (table && table.length) {
        this.setIsPhoneData(idFields, valueToDisplay, lookup, table)
      } else {
        let res: any = this.forkJoinDataForTables[this.lookupData[inde].lookupTableName];
        let data = res.data;
        this.setIsPhoneData(idFields, valueToDisplay, lookup, data)
      }
    }
  }

  setIsPhoneData(idFields, valueToDisplay, lookup, data) {

    if (data && data.length) {
      idFields = data[0].columns.filter(a => a.idField);
      if (idFields && idFields.length) {
        idFields.forEach(item => {
          let valVar = '';
          let obj = {
            val: '',
            isPhone: false,
          }
          if (lookup[item.name]) {
            obj.val = lookup[item.name];
          }

          if (item.isPhone) {
            obj.isPhone = true;
          }

          if (obj.val) {
            valueToDisplay.push(obj);
          }
        })
      }
      lookup["valueToDisplay"] = valueToDisplay;
    }
  }

  dateDiffToString(a, b) {

    let diff = Math.abs(a - b);
    let ms = diff % 1000;
    diff = (diff - ms) / 1000
    let ss: any = diff % 60;
    diff = (diff - ss) / 60
    let mm = diff % 60;
    diff = (diff - mm) / 60
    let hh = diff % 24;
    let days = (diff - hh) / 24
    if (ss < 10) {
      ss = '0' + ss
    }
    if (days > 0) {
      return days + ":" + hh + ":" + mm + ":" + ss;
    } else if (hh > 0) {
      return hh + ":" + mm + ":" + ss;
    } else {
      return mm + ":" + ss;
    }

  }

  getActiveTime(startTime) {
    let currentTime: any = new Date();
    let expireTime: any = new Date(startTime);
    return this.dateDiffToString(currentTime, expireTime);
  }

  getPhoneNumber(phoneNumber) {
    if (phoneNumber) {
      const phonePipe = new PhonePipe();
      const finalPhone = phonePipe.transform(phoneNumber);
      return finalPhone;
    } else {
      return phoneNumber;
    }
  }

  showCalendar(e) {
    this.router.navigateByUrl(
      `pages/calendar`
    );
  }

  logOut() {
    this.authService.logout();
  }

  help() {
    this.showUserCard = false;
  }

  profileMenuClick(menu: any) {
    this.showUserCard = false;
    if (menu == "Profile") {
      const userTableId = "5f60cb6e10fd660a92e9b416";
      this.router.navigateByUrl(
        `pages/tables/dynamic/${userTableId}/Users/${this.userId}`
      );
    } else if (menu == "Settings") {
      this.router.navigate(["/pages/tables/list"]);
    } else if (menu == "Field Restrictions") {
      this.router.navigate(["/pages/tables/Field_Restrictions"]);
    } else if (menu == "Assigned Permissions") {
      this.router.navigate(["/pages/tables/Assigned_Permissions"]);
    } else if (menu == "Users") {
      this.router.navigate(["/pages/tables/Users"]);
    } else if (menu == "System Configurations") {
      this.router.navigate(["/pages/tables/System_Config"]);
    } else if (menu == "Call Log Configurations") {
      this.router.navigate(["/pages/tables/Call_Log_Configurations"]);
    }
  }

  private bufferAudioFile(): void {

    this.audioFile = new Audio();
    this.audioFile.src = this.audioSource;
    this.audioFile.load();
  }

  openReports() {
    this.router.navigate(["pages/reports"]);
  }

  emitMessageSound(): void {
    this.audioFile.play();
  }


  listenGeneralReminders() {
    this.socketService.listen("generic_reminder").subscribe((res: any) => {
      if (res._id !== this.userId) return;
      this.dialogService.open(InfoDialogComponent, {
        context: {
          title: `You have ${res.unreadReminders} new reminders`,
          text: '<a href="" [routerLink]="[\'/pages/tables/notifications\']>View Reminders</a>',
          dialogType: "reminder",
        },
      });
    })
  }

  listenRecordReminders() {

    this.socketService.listen("new_notification").subscribe((res: any) => {

      if (res.subscribers) {
        if (!res.subscribers.find(sub => sub.receiver == this.userId)) {
          return;
        }
      }

      this.notificationCount++;
      this.notificationBadgeText = this.notificationCount.toString();

      //open pop up to show details.
      this.dialogService.open(InfoDialogComponent, {
        context: {
          title: "You have a new notification",
          text: "",
          dialogType: "notification",
          notification: res.resourceDetails,
        },
      });
      this.reminderList.unshift(res);

    });

  }

  listenRecurring() {
    this.socketService.listen('recurring_reminder').subscribe((res: any) => {
      if (res?.createdBy !== this.userId) return;
      this.redirect(res);
    })
  }

  closeReminder(data) {
    this.showNotification = !this.showNotification;
  }

  readNotifications(e?) {

    setTimeout(() => {
      this.showNotification = !this.showNotification;
      this.popover.hide();
      if(e){
        e.stopPropagation();
      }

      this.tableService.runCustomStyling();
    }, 0);
  }
  unreadReminderCount = 0;
  getRemindersList(offset = 20, skip = 0) {
    this.loader = true;
    const checkLoginUser = localStorage.getItem("isFirstTime") ? true : false;
    this.reminderService.myReminders(offset, skip , null , checkLoginUser ? true : null ).subscribe((res: any) => {
      if (res.statusCode == 200) {
        this.tableService.runCustomStyling();
        this.unreadReminderCount = res.data.overDueReminders;
        if (res.data.reminders) {
          this.numberOfPagesLoadedReminder++;
          this.reminderList = [];
          res.data.reminders.forEach((element) => {
            this.updateReminders(element);
          });

          this.tableService.reminderListing(res.data);
          this.loader = false;
        }
      }
    });
  }

  loader = false;
  getNotificationsList(offset = 20, skip = 0) {
    this.loader = true
    this.tableService.myNotifications('log', offset, skip).subscribe((res: any) => {
      if (res.statusCode == 200) {
        this.tableService.runCustomStyling();
        if (res.data.notifications) {
          this.numberOfPagesLoadedNotification++;
          this.notificationList = this.notificationList.concat(res.data.notifications);
          // this.tableService.getNotificationsList(res.data.notifications.slice(0, 5));
          this.unreadNotificationCount = res.data.unreadCount;
          this.notificationList.forEach(ele => {
            if (ele.visibility == 'unread') {
              this.notificationBadgeText = ".";
            }
          })
        }
      }

      this.loader = false;
    })
    console.log('this.notificationList ', this.notificationList)
  }

  updateReminders(data, isNewMessage = false) {

    let apiData;
    let temp = [];
    if (data?.tableName && data?.resourceId) {

      apiData = this.getTablesForMenuData.find(table => table.tableName == data.tableName)

      if (!apiData) return false;

      let IDFields = [];
      apiData.columns.forEach(element => {
        if (element.idField && element.idField == true) {
          IDFields.push(element.name);
        }
      });

      if (IDFields.length) {
        IDFields.forEach((el, i) => {

          if (data && data['record'] && data['record'][el]) {
            let IDElement = apiData["columns"].find(v => v.name == el);

            if (IDElement.type == "date" || IDElement.type == "dateTime") {
              if (typeof data['record'][el] !== 'object') {
                let val = this.datePipe.transform(data['record'][el], "M/d/yy")
                temp.push(' ' + val);
              }
            } else {
              if (typeof data['record'][el] !== 'object') {
                temp.push(' ' + data['record'][el]);
              }
            }
          }
        });
      }
      let dataValue = this?.tableIcon?.[data?.tableName];
      if (dataValue) {
        dataValue = dataValue;
      } else {
        let iconData = this.getTablesForMenuData.filter(v => v.tableName == data?.tableName);
        if (iconData && iconData?.length) {
          dataValue = iconData?.[0]?.iconLocation ? iconData?.[0]?.iconLocation : '';
        }
      }
      let obj = {
        title: "You have new task reminder",
        tableId: data?.tableId,
        tableName: data?.tableName,
        reminderNotes: data?.reminderNotes,
        resourceId: data?.resourceId,
        subject: data?.resourceDetails?.subject,
        description: data?.resourceDetails?.description,
        resourceName: data?.resourceDetails?.resourceName,
        notes: data?.resourceDetails?.reminderNotes || data.notes,
        details: data?.details,
        isNewMessage: isNewMessage,
        subscribers: data?.subscribers,
        notificationId: data?._id,
        dateTime: data.dueDate,
        frequency: data.frequency,
        repeatEveryValue: data.repeatEveryValue,
        repeatEvery: data.repeatEvery,
        start: data.start,
        end: data.end,
        oneTimeDue: data.oneTimeDue,
        toDisplay: temp,
        tableIcon: this.tableIcon,
        createdAt: data.createdAt,
        dueDate: data?.dueDate,
        visibilityStatus: data.visibilityStatus
      };

      this.reminderList.push(obj)

    } else {
      this.reminderList.push({
        title: "You have new task reminder",
        tableId: data?.tableId,
        tableName: data?.tableName,
        reminderNotes: data?.reminderNotes,
        resourceId: data?.resourceId,
        subject: data?.resourceDetails?.subject,
        description: data?.resourceDetails?.description,
        resourceName: data?.resourceDetails?.resourceName,
        notes: data?.resourceDetails?.reminderNotes || data.notes,
        details: data?.details,
        isNewMessage: isNewMessage,
        subscribers: data?.subscribers,
        notificationId: data?._id,
        dateTime: data.dueDate,
        frequency: data.frequency,
        repeatEveryValue: data.repeatEveryValue,
        repeatEvery: data.repeatEvery,
        start: data.start,
        end: data.end,
        oneTimeDue: data.oneTimeDue,
        toDisplay: temp,
        tableIcon: this.tableIcon,
        createdAt: data.createdAt,
        dueDate: data?.dueDate,
        visibilityStatus: data.visibilityStatus
      })
    }
    this.cdr.detectChanges();
    this.reminderList = this.reminderList.filter((obj, pos, arr) => {
      return arr.map(mapObj => mapObj["notificationId"]).indexOf(obj["notificationId"]) === pos;
    })

    this.tableService.setReminderData(this.reminderList);
    this.cdr.detectChanges();
  }

  redirect(notification) {
    notification['reminderDetails'] = notification;
    if(this.showNotification){
      localStorage.removeItem('dashBoardReminder')
    }
    this.dialogService.open(InfoDialogComponent, {
      closeOnEsc: false,
      closeOnBackdropClick: false,
      context: {
        title: ``,
        text: "",
        dialogType: "reminder",
        notification: notification,
        onCloseEvnet : this.showNotification ? false :this.onCloseEvnet
      },
    }).onClose.subscribe((res) => {
      if (res && res?.status == "markDone") {
        let index = this.reminderList.findIndex((x) => x.notificationId == res?.data?.notificationId)
        this.reminderList.splice(index, 1)
        if(!this.onCloseEvnet){
          this.showNotification = !this.showNotification;
        }
      } else if (res && res.status == "stopRecurring") {
        let index = this.reminderList.findIndex((x) => x.notificationId == res?.data?.notificationId)
        this.reminderList[index].frequency = null;
      }
      setTimeout(() => {
        this.onCloseEvnet = false;
        localStorage.removeItem('dashBoardReminder')
      },500)
      this.getRemindersList();
    });
    return false;
  }

  getTablesForMenuData = [];
  getChatSubscription() {
    this.chatSubscriptionService.chatSubscribersSub.subscribe((res: any) => {
      if (res.statusCode == 200 && res.data) {
        res.data.forEach((resourceId: any) => {
          this.messageService.Join(resourceId);
        });
      }
    });
  }

  getAllUsers() {
    this.tableService.getAllUsers().subscribe((res: any) => {
      if (res.statusCode == 200) {
        //let data = res.data.filter(v=> this.allowedUserStatus.includes(v.status));
        this.tableService.$users.next(res.data);
        //this.tableService.$allUsers.next(res.data);
      }
    });
  }

  updateMessageStatus(notification): void {

    const data = {
      receiver: this.userId,
      notification: notification._id,
      participantType: 2,
    };

    if (notification.visibility == "unread") {
      this.socketService.emit("message_status_change", data);
      notification.visibility = 'read';
      this.cdr.detectChanges();
      this.unreadNotificationCount--;
    }
  }

  deletedMessage($event){
    this.unreadNotificationCount--;
  }

  reminderCompleted($event) {
    this.unreadReminderCount--;
  }

  changeUserStatus() {
    const data = {
      id: this.userId,
      status: "Online",
    };
    // this.messageService.userStatusChange(data);
    this.socketService.emit("user_status_change", data);
  }

  keyPressSubscription() {
    this.keySubscription = fromEvent(this.document, "keydown")
      .pipe(throttleTime(1000))
      .subscribe((event) => {
        this.setStatusChangeTimer();
      });
  }

  mouseMoveSubscription() {
    this.mouseSubscription = fromEvent(document, "mousemove")
      .pipe(throttleTime(1000))
      .subscribe((e) => {
        this.setStatusChangeTimer();
      });
  }

  setStatusChangeTimer() {
    const data = { id: this.userId, status: "Online" };
    if (!this.isActive) {
      this.isActive = true;
      // this.messageService.userStatusChange(data);
      this.socketService.emit("user_status_change", data);
    }
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.isActive = false;
      const statusData = { id: this.userId, status: "Away" };
      // this.messageService.userStatusChange(statusData);
      this.socketService.emit("user_status_change", statusData);
    }, 60000);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.keySubscription) {
      this.keySubscription.unsubscribe();
    }
    if (this.mouseSubscription) {
      this.mouseSubscription.unsubscribe();
    }
    if (this.actionSubscription) {
      this.actionSubscription.unsubscribe();
    }
    if (this.logoPathSubscription) {
      this.logoPathSubscription.unsubscribe();
    }
    localStorage.removeItem('dashBoardReminder')
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar() {
    this.sidebarService.toggle(true, "menu-sidebar");
    this.layoutService.changeLayoutSize();
    this.tableService.toggleSidebar.next((this.condtion = !this.condtion));
    return false;
  }

  onEmailClick() {
    this.router.navigate(["/pages/tables/email"]);
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  manageTables() {
    this.router.navigate(["/pages/tables/list"]);
  }

  redirectToNotifications() {
    this.router.navigate(["/pages/tables/notifications"]);
  }

  formatDate(value) {
    if (!value) {
      return "";
    }

    return formatDate(value, "M/d/yy, h:mm a", "en");
  }

  commonUserDetails(res: any) {
    if (res.message.announcements != null && res.message.me.lastClickedOnAnnouncement != undefined && res.message.me.lastClickedOnAnnouncement) {
      const announceClicked = new Date(res.message.me.lastClickedOnAnnouncement).getTime();
      const announceDate = new Date(res.message.announcements.updatedAt).getTime();
      this.isAnnounceRead = !(announceClicked == 0 || announceDate > announceClicked);
    } else {
      this.isAnnounceRead = false;
    }
    this.announcement = res.message.announcements;
    if (res.message.me) {
      if (!this.isAnnounceRead && localStorage.getItem("isFirstTime")) {
        localStorage.setItem("openAnnounceModal", "true");
        this.tableService.announcementSeen().subscribe(
          (res: any) => {
            if (res.statusCode == 200) {
              this.isAnnounceRead = true;
            }
          },
        );
        // this.openAnnouncementBox();
      }
    }
  }
  getAnnouncement() {
    this.socketService.listen("announce_reminder").subscribe((res: any) => {
      let currentDate = this.formatDate(new Date()).toString();
      let activatedDate = this.formatDate(new Date(res.message.announcements.activateDate)).toString();

      if (currentDate === activatedDate) {
        this.tableService.announcementSeen().subscribe(
          (res: any) => {
            if (res.statusCode == 200) {
              this.isAnnounceRead = true;
            }
          },
        );
        this.openActivateAnnouncement(res.message.announcements);
      }
    })
  }

  @HostListener('window:beforeunload') openActivateAnnouncement(res: any) {
    if (res) {
      if (localStorage.getItem("openAnnounceModal") === "true" || localStorage.getItem("isButtonClick") === "true") {
        this.dialogService.open(ShowcaseDialogComponent, {
          context: {
            list: this.anounceList,
            button: this.anounceList && this.anounceList.length ? { text: 'Next Announcement' } : { text: 'Ok' },
            isAnnouncment_table: true,
            firstTimeLogin: true,
          },
          hasBackdrop: true,
        });
      }
    }
  }

  getUserDetail() {
    this.loading = true;
    this.tableService.userDetail().subscribe(
      (res: any) => {
        this.loading = false;
        this.commonUserDetails(res);
      },
    );
  }

  async urlAnnounceTitle() {
    let res: any = await this.tableService.getTableByName("Announcements");
    if (res) {
      const idField = res.data && res.data.length && res.data[0].columns.find((f) => f.idField)?.name;
      this.tableService.currentIdField = idField;

      if (this.getSystemConfigVariable) {
        this.title.setTitle("Announcements" + " - " + this.getSystemConfigVariable["Company Name"]);
      } else {
        this.tableService.$systemConfig.subscribe((configs) => {
          this.title.setTitle("Announcements" + " - " + configs["Company Name"]);
        });
      }

      // this.getTableByNameFnCode(res);
    }
  }

  async openAnnouncementBox() {
    this.urlAnnounceTitle();
    let temp = [];
    if (this.anounceList && this.anounceList.length) {
      this.openActivateAnnouncement(this.anounceList);
    }
  }

  public onSearch(searchStr) {
    if (!!searchStr === true) {
      this.router.navigateByUrl(`/pages/tables/master-search?search=${searchStr}`);
    }
  }


  scrollHandler(type, e) {
    let diff = e.srcElement.scrollTop - (e.srcElement.scrollHeight - 352);
      if (diff == 0) {
        if (!this.loader)
        e.preventDefault();
      }
  }

  onScrollNotification(value) {
    if (value)
      this.getNotificationsList(20, this.numberOfPagesLoadedNotification * 20);
  }
}
